{
  "type": "object",
  "patternProperties": {
    "^.+$": { "$ref": "common_definitions.json#/definitions/ColumnDescription" }
  }
}
